module.exports = __webpack_public_path__ + "img/step4.b08c163f.png";